// extracted by mini-css-extract-plugin
export var documentation = "_lm-1";
export var menu = "_lm-0";